import "./style.scss";

import "./Filter";

import $ from "jquery";
import setQuery from "set-query-string";
import wp from "../../api";
import mustacheTemplate from "./template.mustache";
import lazyload from "../../lazyload";

import { initPhotoSwipe } from "./PhotoSwipeGallery";

$(".work-page-gallery").each((_, el) => {
  const $wrapper = $(el);
  const $searchInput = $wrapper.find(".main-search__input");
  const $categoryFilter = $wrapper.find(".work-page-filter__category");

  const $contentWrapper = $wrapper.find(".work-page-gallery__content");

  const postsPerPage = $wrapper.attr("data-posts-per-page");

  function renderItems(data) {
    return Object.keys(data)
      .map((key) => {
        const items = data[key];
        return mustacheTemplate({ items, heading: key !== "0" && key });
      })
      .join("");
  }

  async function queryItems() {
    const category = $categoryFilter.attr("data-current-category-slug");
    const search = $searchInput.val();

    const items = await wp
      .blogQuery()
      .param("search", search)
      .param("category", category)
      .param("posts-per-page", postsPerPage);

    setQuery({ search, category });

    $(".work-page-gallery__empty-query-message").toggleClass(
      "visible",
      !items || (Array.isArray(items) && !items.length)
    );

    $wrapper.toggleClass("is-query-result", !!search || !!category);

    return items;
  }

  async function handleFilterUpdate() {
    const items = await queryItems();
    const html = renderItems(items);

    $contentWrapper.html(html);
    lazyload.update();
    initPhotoSwipe($contentWrapper.get(0));
  }

  $searchInput.on("input", () => {
    if (!$searchInput.val()) handleFilterUpdate();
  });
  $searchInput.on("input:damped", handleFilterUpdate);

  $categoryFilter.on("change:category", handleFilterUpdate);
});
